let moment = require('moment');

module.exports = {
    setCopyrightYear (args, state) {
        let year = moment().year();
        state.set(['footer', 'year'], year);
    }
};



// WEBPACK FOOTER //
// ./actions/layout/footer.js